import { Button } from "@/components/ui/button"
import { Separator } from "@/components/ui/separator"
import { ReplySvg } from "@/components/svg"
import { useState } from "react"
import SendCommentaire from "./send-commentaire"

const formatTimeAgo = (dateString) => {
  const date = new Date(dateString)
  const now = new Date()
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000)
  
  if (diffInSeconds < 60) return 'Il y a quelques secondes'
  if (diffInSeconds < 3600) return `Il y a ${Math.floor(diffInSeconds / 60)} minutes`
  if (diffInSeconds < 86400) return `Il y a ${Math.floor(diffInSeconds / 3600)} heures`
  return `Il y a ${Math.floor(diffInSeconds / 86400)} jours`
}

const ViewCommentaires = ({comments, commentId, commentBody, articleId, setCommentId, setCommentBody, refreshComments}) => {
  
  const [expandedComments, setExpandedComments] = useState(new Set())

  const toggleComment = (commentId) => {
    setExpandedComments(prev => {
      const newSet = new Set(prev)
      if (newSet.has(commentId)) {
        newSet.delete(commentId)
      } else {
        newSet.add(commentId)
      }
      return newSet
    })
  }
  const toggleReply = (item) => {
    setCommentId(item.cid)
    setCommentBody(removeHTMLTags(item.comment_body))  
  }

  const removeHTMLTags =(htmlString) => {
    const parser = new DOMParser()
    const doc = parser.parseFromString(htmlString, 'text/html')
    const textContent = doc.body.textContent || ""

    return textContent.trim()
  }

  const renderComments = (item, isLast = false, depth = 0) => {
    const isExpanded = expandedComments.has(item.cid)
    const hasChildren = item.children && item.children.length > 0

    return (
      <div key={item.uuid} className={depth > 0 && depth < 5 ? "pl-8" : ""}>
        <div className="mb-4">
          <div className="p-4">
            <div className="flex items-center">
              <p className="mr-2 font-medium">{item.author.name}</p>
              <p className="text-gray-500 text-sm">{formatTimeAgo(item.created)}</p>
            </div>
            <div 
              className="text-gray-600 my-3.5"
              dangerouslySetInnerHTML={{ __html: item.comment_body }}
            />
            <div className="flex items-center gap-4">
              <Button 
                variant="secondary" 
                size="sm" 
                onClick={() => toggleReply(item)}
              >
                <ReplySvg className="mr-2" />
                Répondre
              </Button>
              
              {hasChildren && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => toggleComment(item.cid)}
                  className="text-blue-600 hover:text-blue-700"
                >
                  {isExpanded ? 'Masquer' : item.children.length > 1
                    ? `Voir les ${item.children.length} réponses`
                    : 'Voir la réponse'
                  }
                </Button>
              )}
            </div>
          </div>
          {commentId === item.cid && 
            <SendCommentaire
              commentId={commentId}
              articleId={articleId}
              commentBody={commentBody}
              setCommentId={setCommentId}
              setCommentBody={setCommentBody}
              refreshComments={refreshComments}
            />
          }
          
          {isExpanded && hasChildren && (
            <div>
              {item.children.map((child, index) => 
                renderComments(child, index === item.children.length - 1, depth + 1)
              )}
            </div>
          )}
        </div>
        {!isLast && <Separator className="my-5" />}
      </div>
    )
  }
  
  return (
    <div className="space-y-6">
      {comments.map((comment, index) => 
        renderComments(comment, index === comments.length - 1)
      )}
    </div>
  )
}

export default ViewCommentaires